// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
import { getTemplate, Keys, noop } from '@progress/kendo-vue-common';
import { KEYBOARD_NAV_DATA_ID, KEYBOARD_NAV_DATA_LEVEL } from '@progress/kendo-vue-data-tools';
/**
 * Represents the default `GridGroupCell` component.
 */

var GridGroupCellVue2 = {
  props: {
    id: String,
    field: String,
    dataItem: Object,
    format: String,
    type: String,
    colSpan: Number,
    className: String,
    columnIndex: Number,
    columnsCount: Number,
    rowType: String,
    level: Number,
    expanded: Boolean,
    editor: String,
    dataIndex: Number,
    isSelected: Boolean,
    ariaColumnIndex: Number,
    render: [String, Function, Object]
  },
  // @ts-ignore
  emits: {
    change: null,
    cellkeydown: null
  },
  inject: {
    kendoIntlService: {
      default: null
    },
    getKeyboardNavigationAttributes: {
      default: noop
    }
  },
  methods: {
    triggerKeydown: function triggerKeydown(event, expanded) {
      this.$emit('cellkeydown', {
        event: event,
        dataItem: this.$props.dataItem,
        dataIndex: this.$props.dataIndex,
        field: this.$props.field,
        expanded: this.$props.expanded
      });

      if (event.defaultPrevented) {
        return;
      }

      if (event.keyCode === Keys.enter) {
        event.preventDefault();
        this.$emit('change', {
          dataItem: this.$props.dataItem,
          dataIndex: this.$props.dataIndex,
          event: event,
          level: this.$props.level,
          field: undefined,
          value: !expanded
        });
      }
    },
    clickHandler: function clickHandler(e, dataItem, expanded) {
      e.preventDefault();
      this.$emit('change', {
        dataItem: dataItem,
        dataIndex: this.$props.dataIndex,
        event: e,
        level: this.$props.level,
        field: undefined,
        value: !expanded
      });
    }
  },
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var _this = this;

    var h = gh || createElement;
    var defaultRendering = null;
    var _a = this.$props,
        columnIndex = _a.columnIndex,
        level = _a.level,
        columnsCount = _a.columnsCount,
        rowType = _a.rowType,
        dataItem = _a.dataItem,
        field = _a.field,
        expanded = _a.expanded,
        render = _a.render;
    var navAttrs = this.getKeyboardNavigationAttributes(this.$props.id);

    if (columnIndex === undefined || level === undefined || columnIndex < level || columnsCount === undefined || rowType !== 'groupHeader' || dataItem[field] === undefined) {
      defaultRendering = h("td", {
        key: 'g' + columnIndex,
        "class": "k-group-cell"
      });
    } else if (columnIndex <= level) {
      defaultRendering = h("td", {
        onKeydown: function onKeydown(ev) {
          _this.triggerKeydown(ev, expanded);
        },
        on: this.v3 ? undefined : {
          "keydown": function onKeydown(ev) {
            _this.triggerKeydown(ev, expanded);
          }
        },
        key: 'g-colspan',
        colSpan: columnsCount - columnIndex,
        attrs: this.v3 ? undefined : {
          colSpan: columnsCount - columnIndex,
          role: 'gridcell',
          "aria-colindex": this.$props.ariaColumnIndex,
          "aria-selected": this.$props.isSelected,
          "data-grid-col-index": this.$props.columnIndex,
          tabIndex: navAttrs.tabIndex,
          "data-keyboardnavlevel": navAttrs[KEYBOARD_NAV_DATA_LEVEL],
          "data-keyboardnavid": navAttrs[KEYBOARD_NAV_DATA_ID]
        },
        role: 'gridcell',
        "aria-colindex": this.$props.ariaColumnIndex,
        "aria-selected": this.$props.isSelected,
        "data-grid-col-index": this.$props.columnIndex,
        tabIndex: navAttrs.tabIndex,
        "data-keyboardnavlevel": navAttrs[KEYBOARD_NAV_DATA_LEVEL],
        "data-keyboardnavid": navAttrs[KEYBOARD_NAV_DATA_ID]
      }, [h("p", {
        "class": "k-reset"
      }, [h("a", {
        onClick: function onClick(e) {
          _this.clickHandler(e, dataItem, expanded);
        },
        on: this.v3 ? undefined : {
          "click": function onClick(e) {
            _this.clickHandler(e, dataItem, expanded);
          }
        },
        href: "#",
        attrs: this.v3 ? undefined : {
          href: "#",
          tabIndex: -1
        },
        tabIndex: -1,
        "class": expanded ? 'k-i-collapse k-icon' : 'k-i-expand k-icon'
      }), dataItem[field].toString()])]);
    }

    return getTemplate.call(this, {
      h: h,
      template: render,
      defaultRendering: defaultRendering,
      additionalProps: this.$props,
      additionalListeners: {
        keydown: this.triggerKeydown,
        click: this.clickHandler
      }
    });
  }
};
var GridGroupCell = GridGroupCellVue2;
export { GridGroupCell, GridGroupCellVue2 };